import React from 'react';
import useAnimatedVisibility from '../../../../../elements/AnimatedVisiblilty/useAnimatedVisibility';
import styles from './BubbleMenu.module.scss';
import Chat from './buttons/Chat';
import Favorite from './buttons/Favorite';
import Meeting from './buttons/Meeting';
import Profile from './buttons/Profile';
import Quests from './buttons/Quests';

const BubbleMenu = (props) => {
    const { className = '', event, user, visible } = props,
        buttonProps = { event, user },
        {
            mounted: isMounted,
            visible: isVisible,
            showing,
        } = useAnimatedVisibility({ visible, timeout: 1500 });

    if (!isMounted) return null;

    return (
        <div
            className={[
                styles.BubbleMenu,
                className,
                isVisible ? styles.visible : '',
                showing ? styles.showing : '',
                // DEBUG
                // styles.visible,
            ].join(' ')}>
            <Chat {...buttonProps} />
            <Meeting {...buttonProps} />
            <Favorite {...buttonProps} />
            <Profile {...buttonProps} />
            <Quests {...buttonProps} />
        </div>
    );
};

export default BubbleMenu;
